import { z } from 'zod';

/**
 * Os motores de emissão de nota fiscal de serviço (`.spec/015`, decisão 89).
 *
 * **Motor** é quem transforma a nota do sistema numa NFS-e autorizada: uma API
 * de terceiro (Notaas, TecnoSpeed, Focus), um componente próprio (ACBr), ou a
 * pessoa que digita no portal da prefeitura. O sistema não é amarrado a nenhum:
 * a conta escolhe o dela na Configuração (`ADM·02`), e trocar de fornecedor é
 * trocar esse campo — os cadastros, a nota e o título a receber não sabem qual
 * motor está em uso.
 *
 * ## Como entra um motor novo
 *
 * 1. O código dele entra nesta lista, com rótulo e descrição.
 * 2. Em `apps/api/src/modules/contratos/nota-servico/motores/`, um arquivo
 *    implementa a porta `MotorDeNfse`.
 * 3. O arquivo entra no `Record<MotorNfse, MotorDeNfse>` de `registro.ts` — que
 *    **não compila** enquanto o passo 2 não existir. É o que impede oferecer na
 *    tela um motor que o servidor não sabe chamar.
 *
 * Nada mais muda: a tabela guarda o código como texto, o `CHECK` dela é
 * regerado da lista, e nenhum service tem `if (motor === …)`.
 *
 * ## Por que só o Manual hoje
 *
 * A fase 1 (06/10/2026) preparou o sistema — cadastros, a nota, o título — e a
 * fase 2 liga a primeira API. O Manual não é paliativo: ele exercita a porta
 * inteira (emitir, cancelar, o que falta para emitir) sem depender de contrato
 * com fornecedor, e continua sendo o motor de quem emite pelo portal.
 */
export const MOTORES_NFSE = ['MANUAL'] as const;
export const motorNfseSchema = z.enum(MOTORES_NFSE);
export type MotorNfse = z.infer<typeof motorNfseSchema>;

/** O motor de toda conta que nunca abriu a configuração. */
export const MOTOR_NFSE_PADRAO: MotorNfse = 'MANUAL';

export const ROTULO_MOTOR_NFSE: Readonly<Record<MotorNfse, string>> = {
  MANUAL: 'Manual — emitida fora do sistema',
};

export const DESCRICAO_MOTOR_NFSE: Readonly<Record<MotorNfse, string>> = {
  MANUAL:
    'A nota é emitida no portal da prefeitura ou no Emissor Nacional, e o número dela é informado aqui. O sistema guarda a nota e gera o contas a receber; não transmite nada.',
};
